<template>
  <v-dialog :model-value="isOpen" opacity = "0.5" persistent>
    <template #default>
      <div class="d-flex justify-center mt-6">
        <v-card
          :width="mobile ? '90%' : '65%'"
          max-height="78vh"
          color="white"
          elevation="3"
          class="d-flex flex-column"
        >
          <v-toolbar flat density="compact" color="white">
            <div class="d-flex align-center">
              <v-btn icon color="primary" @click="close()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
            
            <v-chip variant="tonal" color="primary" v-if="customerModel.customerId">
              ID: {{ customerModel.customerId }}
            </v-chip>
    
            <v-spacer />
    
            <v-btn @click="deleteCustomer()" icon color="primary">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-toolbar>

          <v-form ref="form" class="card-scroll">
            <v-row dense class="pa-8 flex-grow-1 card-scroll">
              <v-col cols="12">
                <v-sheet >
                   <div class="d-flex align-center mb-4">
                    <v-icon color="primary" class="mr-2" size="small">mdi-card-account-details</v-icon>
                    <span class="text-subtitle-1 text-primary" style="color: #1F4529;">Identificação</span>
                  </div>
                </v-sheet>
                <v-divider class="mb-4"></v-divider>
              </v-col>
              <v-col cols="12" lg="3" md="3">
                <div>
                  <v-radio-group inline color="primary" v-model="documentTypeSelector" readonly>
                    <v-radio label="CPF" :value="DocumentType.CPF"></v-radio>
                    <v-radio label="CNPJ" :value="DocumentType.CNPJ"></v-radio>
                  </v-radio-group>
                </div>
              </v-col>
              <v-col cols="12" md="4">
                <div>
                  <v-text-field
                    v-model="customerModel.document"
                    label="CPF/CNPJ"
                    variant="outlined"
                    rounded
                    color="primary"
                    density="compact"
                    max-width="250px"
                    :rules="[
                      v => !!v || 'Campo obrigatório',
                      v => /^\d+$/.test(v) || 'Somente números',
                      v => v.length <= 14 || 'Máximo 14 dígitos',
                      v => v.length >= 11 || 'Mínimo 11 dígitos',
                    ]"
                    @input="customerModel.document = customerModel.document?.replace(/\D/g, '').slice(0,14)"
                  />
                </div>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="12">
                <v-sheet >
                   <div class="d-flex align-center mb-4">
                    <v-icon color="primary" class="mr-2" size="default">mdi-account-box-outline</v-icon>
                    <span class="text-subtitle-1 text-primary" style="color: #1F4529;">Dados pessoais</span>
                  </div>
                </v-sheet>
                <v-divider class="mb-4"></v-divider>
              </v-col>
              <v-col cols="12">
                <div>
                  <v-text-field
                    v-model="customerModel.customerName"
                    label="Nome Completo / Razão Social"
                    variant="outlined"
                    rounded
                    density="compact"
                    :rules="[v => !!v || 'Campo obrigatório']"
                  />
                </div>
              </v-col>
              <v-col cols="12">
                <div>
                  <v-text-field
                    v-model="customerModel.tradeName"
                    label="Nome Fantasia"
                    variant="outlined"
                    rounded
                    density="compact"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div>
                  <v-text-field
                    v-model="customerModel.phone"
                    label="Telefone"
                    variant="outlined"
                    rounded
                    density="compact"
                    prepend-inner-icon="mdi-phone"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div>
                  <v-text-field
                    v-model="customerModel.email"
                    label="E-mail"
                    variant="outlined"
                    rounded
                    density="compact"
                    prepend-inner-icon="mdi-email"
                  />
                </div>
              </v-col>
              <v-col cols="12">
                <v-sheet >
                   <div class="d-flex align-center mb-4">
                    <v-icon color="primary" class="mr-2" size="default">mdi-map-marker-outline</v-icon>
                    <span class="text-subtitle-1 text-primary" style="color: #1F4529;">Endereço</span>
                  </div>
                </v-sheet>
                <v-divider class="mb-4"></v-divider>
              </v-col>
              <v-col cols="12" md="4" sm="5">
                <div>
                  <v-text-field
                    v-model="zipCodeFormatted"
                    label="Cep"
                    variant="outlined"
                    rounded
                    density="compact"
                    maxlength="9"
                    @keyup.enter="searchCep()"
                  >
                    <template v-slot:prepend-inner>
                      <v-btn
                        icon
                        size="small"
                        variant="text"
                        @click="searchCep()"
                      >
                        <v-icon class="pt-1">mdi-magnify</v-icon>
                      </v-btn>
                    </template>
                  </v-text-field>
                </div>
              </v-col>
              <v-col cols="12" md="8">
                <div>
                  <v-text-field
                    v-model="customerModel.address"
                    label="Endereço"
                    variant="outlined"
                    rounded
                    density="compact"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="4" sm="4">
                <div>
                  <v-text-field
                    v-model="customerModel.addressNumber"
                    label="Número"
                    variant="outlined"
                    rounded
                    density="compact"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="4" sm="8">
                <div>
                  <v-text-field
                    v-model="customerModel.complement"
                    label="Complemento"
                    variant="outlined"
                    rounded
                    density="compact"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="4" sm="6">
                <div>
                  <v-text-field
                    v-model="customerModel.district"
                    label="Bairro"
                    variant="outlined"
                    rounded
                    density="compact"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="6" sm="6">
                <div>
                  <v-text-field
                    v-model="customerModel.city"
                    label="Cidade"
                    variant="outlined"
                    rounded
                    density="compact"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="6" sm="6">
                <div>
                  <v-autocomplete
                    v-model="customerModel.state"
                    :items="customer.lstStates"
                    :item-title="item => `${item.uf} - ${item.name}`"
                    item-value="uf"
                    label="Estado"
                    variant="outlined"
                    rounded
                    density="compact"
                  />
                </div>
              </v-col>
            </v-row>
          </v-form>
          <v-card-actions class="mt-n6 pb-6 pr-6">
            <div class="d-flex flex-column flex-md-row w-100 justify-end">
              <v-btn
                rounded
                variant="flat"
                @click="close()"
              >
                Cancelar
              </v-btn>
              <v-btn
                rounded
                color="primary"
                class="ml-2"
                variant="elevated"
                @click="save()"
              >
                Salvar
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </div>
    </template>
  </v-dialog>
</template>


<script>
import { useDisplay } from 'vuetify'
import { DocumentType } from '@/enums/documentType.js'

export default {
  setup () {
    const { mobile } = useDisplay()
    return { mobile }
  },
  data: () => ({
    customerId: '',
    DocumentType,
    documentTypeSelector: null
  }),
  computed: {
    customer: {
      get() {
        return this.$store.state.customer
      }
    },
    customerModel: {
      get() {
          return this.$store.state.customer.customer
      },
    },
    isOpen: {
      get() {
        return Boolean(this.$route.params.customerId || this.$route.name == 'NewCustomer')
      },
      set(value) {
        if (!value) {
          this.$router.push({ name: 'CustomerGrid' })
        }
      }
    },
    zipCodeFormatted: {
      get() {
        const zip = this.customerModel.zipCode || ''
        const digits = zip.replace(/\D/g, '')

        if (digits.length <= 5) return digits
        return `${digits.slice(0, 5)}-${digits.slice(5, 8)}`
      },
      set(value) {
        this.customerModel.zipCode = value.replace(/\D/g, '').slice(0, 8)
      }
    }
  },
  methods: {
    async save() {
      const { valid } = await this.$refs.form.validate()
      if (!valid) return

      const success = await this.$store.dispatch("customer/save")
      if (success) {
        this.$store.commit('customer/setShouldReload', true)
        this.close()
      }
    },
    close() {
      this.$router.push({ name: 'CustomerGrid' })
    },
    async deleteCustomer() {
      const confirmed = await this.$store.dispatch('systemDialogOptions/confirm', null, { root: true })
      if (!confirmed) 
          return false

      const success = await this.$store.dispatch("customer/delete")
      if (success) {
        this.$store.commit('customer/setShouldReload', true)
        this.close()
      }
    },
    async searchCep() {
      await this.$store.dispatch("customer/searchCep")
    }
  },
  watch: {
    '$route.params.customerId': {
      immediate: true,
      async handler(id) {
        if(id) {
          await this.$store.dispatch('customer/find', id)
        } else {
          this.$store.commit('customer/initForm')
        }
      }
    },
    'customerModel.document': {
      immediate: true,
      handler(document) {
        if (document) {
          if (!document) {
            this.documentTypeSelector = null
            return
          }
          
          const digits = document.replace(/\D/g, '')

          this.documentTypeSelector =
            digits.length > 11
              ? DocumentType.CNPJ
              : DocumentType.CPF
        }
      }
    }
  }
}
</script>


<style>

.card-scroll {
  overflow-y: auto;
  scrollbar-width: thin;
}
</style>